import { React, useState } from "react";
import { 
  Button,
  Grid,
  GridColumn,
  GridRow,
  Header, 
  Icon,
} from "semantic-ui-react"

export default function Footer(props) {
  const { setSelection } = props
  const [b1Hovered, setB1Hovered] = useState(false)
  const [b2Hovered, setB2Hovered] = useState(false)
  const [b3Hovered, setB3Hovered] = useState(false)
  const [icon1Hovered, setIcon1Hovered] = useState(false)
	const [icon2Hovered, setIcon2Hovered] = useState(false)

  const footerItemStyle = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
    fontWeight: "normal",
    marginBottom: "0.5em",
    padding: "0em",
    backgroundColor: "transparent",
    fontSize: "1em",
  }

  const footerItemStyleHover = {
    fontFamily: "'Andika', sans-serif",
    color: "#92A082",
    fontWeight: "bold",
    marginBottom: "0.5em",
    padding: "0em",
    backgroundColor: "transparent",
    fontSize: "1em",
    transition: "color 1s ease, border-bottom-color 1s ease",
  }

  const iconStyle = {
    color: "#F9F9F9",
  	opacity: "1",
  }

  const iconStyleHover = {
    color: "#92A082",
  	opacity: "1",
    transition: "color 1s ease, border-bottom-color 1s ease",
  }

  const h1Style = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
		fontSize: "2em",
  }

  const pStyle = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
		fontSize: "1.1em",
  }

  function PageSelectProducts() {
    setSelection("products");
    window.scrollTo(0, 0);
  }

	function PageSelectContactUs() {
    setSelection("contactUs");
    window.scrollTo(0, 0);
  }

  return(
    <footer style={{ backgroundColor: "#8C8C8C" }}>
      <Grid
        stackable
        centered
        columns={2}
        style={{
          padding: "5em 1em 5em 1em",
        }}
      >
        <GridRow style={{ maxWidth: "1200px", }}>
          <GridColumn>
            <Header
              as="h2"
              content="Follow us"
              style={h1Style}
            />
            <Button
                href='https://www.facebook.com/p/Splinters-Woodwork-100057562355381/?paipv=0&eav=AfZfeHMW3CBx9QYuB6KoZnu04yjyGfFTHh3NeZePZBcNaTJT4Ea8fgOJec_sCHMMsLI&_rdr'
                target='_blank'
                aria-label="Follow Splinters Woodwork on Facebook"
                style={{
                  backgroundColor: "transparent",
                  padding: "0em",
                  margin: "0em",
                }}
              >
                <Icon 
                  name='facebook'
                  size='big'
                  onMouseEnter={() => setIcon1Hovered(true)}
                  onMouseLeave={() => setIcon1Hovered(false)}
                  style={icon1Hovered ? (iconStyleHover) : (iconStyle)}
                />
              </Button>
              <Button
                href='https://www.instagram.com/splinters_woodwork/'
                target='_blank'
                aria-label="Follow Splinters Woodwork on Instagram"
                style={{
                  backgroundColor: "transparent",
                  padding: "0em",
                  margin: "0em",
                }}
              >
                <Icon 
                  name='instagram'
                  size='big'
                  onMouseEnter={() => setIcon2Hovered(true)}
                  onMouseLeave={() => setIcon2Hovered(false)}
                  style={icon2Hovered ? (iconStyleHover) : (iconStyle)}
                />
              </Button>
          </GridColumn>

          <GridColumn>
            <Header
              as="h2"
              content="Explore"
              style={h1Style}
            />
            <Button
              content='Products'
              onClick={PageSelectProducts}
              aria-label="Learn more about Splinters Woodwork"
              onMouseEnter={() => setB1Hovered(true)}
              onMouseLeave={() => setB1Hovered(false)}
              style={b1Hovered ? (footerItemStyleHover) : (footerItemStyle)}
            />
            <br/>
            <Button
              content='Contact Us'
              onClick={PageSelectContactUs}
              aria-label="Contact Splinters Woodwork"
              onMouseEnter={() => setB2Hovered(true)}
              onMouseLeave={() => setB2Hovered(false)}
              style={b2Hovered ? (footerItemStyleHover) : (footerItemStyle)}
            />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow>
          <GridColumn textAlign="right" style={{ padding: "0em 3em 1em 0em" }}>
            <p style={pStyle}>Website by&nbsp;
              <Button
                content='Zeteo'
                href='https://zeteo.studio/'
                target='_blank'
                aria-label="Visit Zeteo"
                onMouseEnter={() => setB3Hovered(true)}
                onMouseLeave={() => setB3Hovered(false)}
                style={b3Hovered ? (footerItemStyleHover) : (footerItemStyle)}
              />
            </p>
          </GridColumn>
        </GridRow>
      </Grid>
    </footer>
  )
}